<!-- src/components/Footer.vue -->
<template>
  <footer class="w-full py-4 mt-auto border-t border-slate-200 dark:border-gray-800 bg-white/50 dark:bg-gray-900/50 backdrop-blur-sm">
    <div class="container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-x-6 gap-y-2">
      <span class="text-[10px] font-bold text-slate-400 dark:text-gray-500 uppercase tracking-[0.2em]">
        Sistema de Gestión Integral
      </span>
      
      <div class="hidden md:block h-3 w-px bg-slate-300 dark:bg-gray-700"></div>

      <div class="flex items-center gap-1.5 text-xs text-slate-500 dark:text-gray-400">
        <span class="opacity-80">Desarrollado con</span>
        <Icon icon="mdi:heart" class="text-rose-500 animate-pulse text-sm" />
        <span class="opacity-80">por</span>
        <a 
          href="https://www.sistemas-jj.com" 
          target="_blank" 
          rel="noopener noreferrer"
          class="font-black text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 transition-colors tracking-tight"
        >
          SYSTEM JJ C.A.
        </a>
      </div>

      <div class="hidden md:block h-3 w-px bg-slate-300 dark:bg-gray-700"></div>

      <span class="text-[10px] text-slate-400 dark:text-gray-600 font-medium">
        © 2026 Todos los derechos reservados
      </span>
    </div>
  </footer>
</template>

<script>
import { Icon } from "@iconify/vue";

export default {
  name: "MainFooter",
  components: {
    Icon
  }
};
</script>